import _ from 'lodash';
import { attribute } from './constants';
export var prefixId = function prefixId(id) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
  return "".concat(id).startsWith(prefix) ? "".concat(id) : "".concat(prefix).concat(id);
};
export var prefixFieldIds = function prefixFieldIds(fields) {
  var destinationAttribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : attribute.ID;
  fields.forEach(function (field) {
    field[destinationAttribute] = prefixId(field[attribute.ID]);
  });
};
export var filterFieldsByFieldIds = function filterFieldsByFieldIds(fields, fieldsIds) {
  return fields.filter(function (field) {
    return fieldsIds.includes(field[attribute.ID]);
  });
};

var collectUniqFromFiledList = function collectUniqFromFiledList(fields, filterFn, getValue) {
  var uniq = new Set();
  fields.filter(filterFn).forEach(function (f) {
    var val = getValue(f);
    uniq.add(val);
  });
  return Array.from(uniq);
};

export var getSteps = function getSteps(fields) {
  return collectUniqFromFiledList(fields, function () {
    return true;
  }, function (f) {
    return f[attribute.STEP];
  }).sort();
};
export var getStepSections = function getStepSections(fields, stepNumber) {
  return collectUniqFromFiledList(fields, function (f) {
    return f[attribute.STEP] === stepNumber;
  }, function (f) {
    return f[attribute.SECTION];
  });
};
export var getSectionFields = function getSectionFields(fields, stepNumber, section) {
  return collectUniqFromFiledList(fields, function (f) {
    return f[attribute.STEP] === stepNumber && f[attribute.SECTION] === section;
  }, function (f) {
    return f[attribute.ID];
  });
};
export var getFieldHierarchy = function getFieldHierarchy(fields) {
  var steps = getSteps(fields);
  var hierarchy = []; // Build step array

  steps.forEach(function (stepNumber) {
    var firstMatchingField = fields.find(function (f) {
      return f[attribute.STEP] === stepNumber;
    });

    var stepTitle = _.get(firstMatchingField, attribute.STEP_TITLE, '');

    var stepHierarchy = {
      stepNumber: stepNumber,
      title: stepTitle,
      sections: []
    };
    var sections = getStepSections(fields, stepNumber); // Build section array inside of step

    sections.forEach(function (section) {
      var sectionHierarchy = {
        title: section,
        fields: []
      };
      var sectionFields = getSectionFields(fields, stepNumber, section); // Build fields arary inside of section

      sectionFields.forEach(function (field) {
        sectionHierarchy.fields.push(field);
      });
      stepHierarchy.sections.push(sectionHierarchy);
    });
    hierarchy.push(stepHierarchy);
  });
  return hierarchy;
};